import { StoreOfferProduct } from '@common'

import { Hero } from './Hero'
import { Item } from '../Item'
import { Grid, GridItem } from '../Item/ItemsGrid'

import styles from './Content.module.scss'

type Props = {
  product: StoreOfferProduct
}

export const Content = ({ product }: Props) => {
  return (
    <div className={styles.Content}>
      <Hero product={product} />
      <div className={styles.GridContainer}>
        <Grid>
          {product.contents.map((content, index) => (
            <GridItem key={`product-${product.id}-content-${index}`} gameId={product.game}>
              <Item gameId={product.game} content={content} />
            </GridItem>
          ))}
        </Grid>
      </div>
    </div>
  )
}
